var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showMessageBox
    ? _c("div", { staticClass: "message-box-common flex-center" }, [
        _c("div", { staticClass: "message-box-main" }, [
          _c(
            "div",
            { staticClass: "message-box-top" },
            [
              _c("div", { staticClass: "message-box-title" }, [
                _c("h4", { staticClass: "flex-center" }, [
                  _vm._v(_vm._s(_vm.title)),
                ]),
                _c("i", {
                  staticClass: "icon icon-close",
                  on: { click: _vm.onShowMessageBox },
                }),
              ]),
              _vm._t("top"),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "message-box-content" },
            [_vm._t("content")],
            2
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }